import { QueryClient } from "@tanstack/react-query";

// For every query and mutation. No fetch() in the app retries, and each fails
// at once when offline: TanStack's default "online" network mode would pause it
// until the connection came back.
export const queryClientDefaults = {
  queries: {
    retry: false,
    networkMode: "always",
  },
  mutations: {
    networkMode: "always",
  },
};

export const buildQueryClient = () => new QueryClient({ defaultOptions: queryClientDefaults });

const queryClient = buildQueryClient();
export default queryClient;
